module.exports = __webpack_public_path__ + "590c6804f26130c328ab212be578d2c5.svg";